import {get, post, put, retire} from "$lib/api";

export const getEmployee = async (projectUuid:number, employeeId: number) => {
    return await get(`/employee/${projectUuid}/${employeeId}`)
}

export const listEmployees = async ( conditions:any) => {
    const query =  new URLSearchParams(conditions).toString()
    return await get(`/employees?${query}`);
}
export const countEmployees = async () => {
    return await get(`/employees/count`);
}


export const saveEmployee = async (employee: any) => {
    return await put(`/employee/${employee.uuid}`, employee);
}

export const deleteEmployeeImage = async (employeeUuid: string, employeeImage: any) => {
    return await retire(`/employee/${employeeUuid}/image/${employeeImage.id}`);
}

export const createContract = async (employeeUuid: string, data: any) => await post(`/employee/${employeeUuid}/contract`, data)

export const extendContract = async (employeeUuid: string, data: any) => await post(`/employee/${employeeUuid}/contract/${data.contract.id}/prolong`, data)

export const retireContract = async (employeeUuid: string, contractId: number) => await retire(`/employee/${employeeUuid}/contract/${contractId}`)

export const storeReminder = async (employeeUuid: string, data: any) => await post(`/employee/${employeeUuid}/reminder`, data)